/**
 * Places the Basic Shirt image comparison in its own desktop grid row below
 * the full gallery and between purchase controls and details on mobile.
 */
(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function placeSlider(slider) {
    const productInformation = slider.closest('.product-information');
    if (!productInformation) return;

    const anchor = productInformation.querySelector('.bc-before-after-slider-anchor');
    const buyButtons = productInformation.querySelector('.buy-buttons-block');
    const comparison = slider.closest('.product-information__comparison');

    if (!anchor || !comparison) return;

    if (mobileQuery.matches && buyButtons) {
      buyButtons.after(comparison);
      return;
    }

    anchor.after(comparison);
  }

  function placeAllSliders() {
    document.querySelectorAll('.bc-before-after-slider').forEach(placeSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeAllSliders, { once: true });
  } else {
    placeAllSliders();
  }

  mobileQuery.addEventListener('change', placeAllSliders);
  document.addEventListener('shopify:section:load', placeAllSliders);
})();
